<template>
  <div class="uom-details">
        <v-card>
            <v-card-actions class="shade ma-0 pa-0">
              <v-spacer></v-spacer>
              <v-btn small text color="blue" :disabled="!valid" class="text-capitalize" @click="apply()">
                Apply
              </v-btn>
              <v-btn small text color="blue" class="text-capitalize" @click="cancel()">
                Cancel
              </v-btn>
            </v-card-actions>
          <v-card-title>
            Unit of Measure
          </v-card-title>

              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    data-cy="name-text-field"
                    ref="uom"
                    v-model="name"
                    :rules="[() => !!name || 'Name is required']"
                    label="Unit Of Measure"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="desc-text-field"
                    ref="description"
                    v-model="description"
                    label="Description"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="min-text-field"
                    ref="max"
                    v-model="max"
                    :rules="[numberRule]"
                    label="Max Value"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="max-text-field"
                    ref="min"
                    v-model="min"
                    :rules="[numberRule]"
                    label="Min Value"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="steps-text-field"
                    ref="steps"
                    v-model="steps"
                    :rules="[numberRule]"
                    label="Steps"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="precision-text-field"
                    ref="precision"
                    v-model="precision"
                    :rules="[numberRule]"
                    label="Precision"
                    class="ma-1"
                  >
                  </v-text-field>

                </v-form>
              </v-card-text>
              <v-card-actions>
            <v-container>
              <v-row dense>
                <v-btn
                  data-cy="submit-form"
                  color="primary"
                  :disabled="!valid"
                  text @click="apply">Submit</v-btn>
              </v-row>
            </v-container>
              </v-card-actions>







        </v-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiDelete } from '@mdi/js'
import { clone } from 'lodash';

export default {
  name: 'UomDetails',
  components: {
  },
  data: () => {
    return {
      svgPath: mdiDelete,
      valid: false,
      formHasErrors: false,
      name: null,
      description: null,
      max: null,
      min: null,
      steps: null,
      precision: null,
      id: null,
      numberRule: v  => {
        if (!v) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) return true;
        return 'Number has to be between 0 and 999';
      },
    }
  },
  beforeCreate() {},

  created() {
    if (this.uom) {
      this.name = clone(this.uom.name)
      this.description = clone(this.uom.description)
      this.max = clone(this.uom.max)
      this.min = clone(this.uom.min)
      this.steps = clone(this.uom.steps)
      this.precision = clone(this.uom.precision)
      this.id = clone(this.uom.id)
    }
  },

  mounted() {
   },

  beforeDestroy() {
  },

  computed: {
    ...mapGetters({
      uom: 'getSelectedUom',
    }),
  },

  methods: {
    cancel () {
      this.$router.push({name: 'Uom' })
    },
    apply () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('applyUomDetails', {id: this.id, name: this.name, description: this.description, max: this.max, min: this.min, steps: this.steps, precision: this.precision});
        this.$router.push({name: 'Uom' })
      }
    }
  },


}
</script>

<style lang="scss" scoped>
.uom-details {

}
</style>
